import { render, staticRenderFns } from "./menberDetail.vue?vue&type=template&id=dfcb62d4&scoped=true&"
import script from "./menberDetail.vue?vue&type=script&lang=js&"
export * from "./menberDetail.vue?vue&type=script&lang=js&"
import style0 from "./menberDetail.vue?vue&type=style&index=0&id=dfcb62d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfcb62d4",
  null
  
)

export default component.exports